module.exports = __webpack_public_path__ + "img/belize.c08d4857.png";